import { inject, Injectable } from '@angular/core';
import { AxiosHttpService } from './axios-http.service';
import { ApiResponse } from '../interfaces/api-response.model';
import {
  BusinessPlanRequest,
  BusinessPlanResponse,
  UserPlanResponse,
} from '../interfaces/reserve-loading.model';
import { UserPlanRequest } from '../interfaces/reserve-health.model';
import { API_ENDPOINTS } from '../constants/api.constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * 預約方案演算等待頁面
 */
@Injectable({
  providedIn: 'root',
})
export class ReserveLoadingService {
  http: HttpClient = inject(HttpClient);
  axiosHttpService: AxiosHttpService = inject(AxiosHttpService);

  /**
   * 查詢個人方案結果
   * @param userPlanRequest 健康調查表內容
   */
  getUserPlanResult(
    userPlanRequest: UserPlanRequest
  ): Observable<ApiResponse<UserPlanResponse>> {
    const payload = {
      age: userPlanRequest.age,
      gender: userPlanRequest.gender,
      identityType: userPlanRequest.identityType,
      funcType: userPlanRequest.funcType,
      idNo: userPlanRequest.idNo,
      orgNo: userPlanRequest.orgNo,
      history: userPlanRequest.history,
      family: userPlanRequest.family,
      subjectiveSymptoms: userPlanRequest.subjectiveSymptoms,
      isPregnant: userPlanRequest.femaleStatus,
      isMenopausal: userPlanRequest.femaleMenopausal,
      questionnaireId: 20,
      entQuestionnaireId: 681,
      companyNo: 1150,
      fractureAnswer: userPlanRequest.fractureAnswer || '',
      cancerAnswer: userPlanRequest.cancerAnswer || '',
    };
    return this.http.post<ApiResponse<UserPlanResponse>>(
      API_ENDPOINTS.GET_USER_PLAN,
      payload
    );
  }

  /**
  * 查詢企業健檢方案
  * @param request 企業健檢方案請求
  */
  getBusinessPlanResult(
    request: BusinessPlanRequest
  ): Observable<ApiResponse<BusinessPlanResponse>> {
    const paramsObj: Record<string, string> = {
      orgNo: request.orgNo,
      companyNo: request.companyNo,
      gender: request.gender,
      idNo: request.idNo ?? '',
      employeeId: request.employeeId ?? '',
    };

    if (request.employeeId !== undefined && request.employeeId !== null) {
      paramsObj['employeeId'] = request.employeeId;
    }

    const params = new URLSearchParams(paramsObj).toString();
    const url = `${API_ENDPOINTS.ENTERPRISE_PLAN}?${params}`;
    
    return this.http.get<ApiResponse<BusinessPlanResponse>>(url);
  }
}
